import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { NAV_LINKS } from '../constants/brand';

export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <motion.header
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.5 }}
      className={`
        fixed top-0 left-0 right-0 z-50
        transition-all duration-300
        ${isScrolled ? 'glass-header py-3' : 'bg-transparent py-5'}
      `}
      data-testid="header"
    >
      <div className="container mx-auto px-4 md:px-8">
        <nav className="flex items-center justify-between">
          {/* Logo */}
          <a 
            href="#hero" 
            onClick={(e) => {
              e.preventDefault();
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }}
            className="inline-flex items-center"
            data-testid="header-logo"
            aria-label="AYA home"
          >
            <img
              src="/app_icon_trans.png"
              alt="AYA"
              className="h-[4.5rem] w-auto md:h-20 lg:h-24"
            />
          </a>

          {/* Navigation Links */}
          <div className="flex items-center gap-4 md:gap-8">
            {NAV_LINKS.map((link) => (
              <button
                key={link.href}
                onClick={() => scrollToSection(link.href)}
                className="
                  text-sm md:text-base text-white/70 
                  hover:text-white transition-colors duration-200
                  hidden sm:block
                "
                data-testid={`nav-${link.label.toLowerCase().replace(/\s+/g, '-')}`}
              >
                {link.label}
              </button>
            ))}
            
            {/* Mobile Waitlist CTA */}
            <button
              onClick={() => scrollToSection('#waitlist')}
              className="
                hero-outline-btn rounded border border-aya-yellow
                px-4 py-2 text-sm font-semibold text-aya-yellow
                transition-colors duration-200
                sm:hidden
              "
              data-testid="mobile-waitlist-cta"
            >
              Waitlist
            </button>
          </div>
        </nav>
      </div>
    </motion.header>
  );
};

export default Header;
